import React, { useEffect, useState } from "react";
import { BiChat, BiSolidUser } from "react-icons/bi";
import { HiOutlineArrowDownRight, HiArrowUpLeft } from "react-icons/hi2";
import { AiFillLock, AiFillSave } from "react-icons/ai";
import { PiArrowsClockwiseBold, PiWalletBold } from "react-icons/pi";
import { CiMail } from "react-icons/ci";
import { GoLocation, GoRocket } from "react-icons/go";
import { BiSolidCity, BiHistory } from "react-icons/bi";
import { FaBan, FaEye } from "react-icons/fa";
import { AiFillSetting } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import { HiDocumentDownload } from "react-icons/hi";
import {
  Button,
  DatePicker,
  Dropdown,
  Input,
  InputNumber,
  Modal,
  Spin,
  Switch,
} from "antd";
import eyeimage from "../../../assests/icons/Frame 58.png";
import secure from "../../../assests/icons/ri_secure-payment-fill.png";
import { useParams } from "react-router";
import handleGet from "../../../utils/Get";
import { BASE_URL } from "../../../utils/config";
import handlePost from "../../../utils/Post";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import Support from "../support";
import TicketTable from "../../../components/tickettable";

const { TextArea } = Input;

const NAV_ITEMS = [
  { key: "first", icon: BiSolidUser, label: "General" },
  { key: "second", icon: AiFillLock, label: "Assets" },
  { key: "third", icon: PiWalletBold, label: "Transactions" },
  { key: "fourth", icon: AiFillSetting, label: "Verification" },
  { key: "fifth", icon: BiHistory, label: "History" },
  { key: "sixth", icon: BiChat, label: "Support" },
];

const Field = ({ label, children }) => (
  <div className="mb-4">
    <label className="block text-xs font-semibold text-[#8B8FA8] uppercase tracking-widest mb-1.5">
      {label}
    </label>
    {children}
  </div>
);

const Badge = ({ status }) => {
  const map = {
    approved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    declined: "bg-red-500/10 text-red-400 border-red-500/30",
    pending: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    active: "bg-sky-500/10 text-sky-400 border-sky-500/30",
  };
  const cls = map[(status || "pending").toLowerCase()] || map.pending;
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {status || "Pending"}
    </span>
  );
};

const GlowBtn = ({ children, onClick, loading, variant = "primary", className = "" }) => {
  const base = "inline-flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 disabled:opacity-40";
  const variants = {
    primary: "bg-[#6C5DD3] hover:bg-[#7B6AE0] text-white shadow-[0_0_20px_rgba(108,93,211,0.3)] hover:shadow-[0_0_30px_rgba(108,93,211,0.5)]",
    danger: "bg-[#1A0D0D] border border-red-500/40 hover:border-red-500/70 text-red-400 hover:text-red-300",
    ghost: "bg-[#161826] border border-[#2A2D3E] hover:border-[#6C5DD3]/50 text-[#8B8FA8] hover:text-white",
    success: "bg-[#0D1A12] border border-emerald-500/40 hover:border-emerald-500/70 text-emerald-400 hover:text-emerald-300",
  };
  return (
    <button onClick={onClick} disabled={loading} className={`${base} ${variants[variant]} ${className}`}>
      {loading ? <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" /> : children}
    </button>
  );
};

const darkInputStyle = { background: "#0D0F1A", borderColor: "#2A2D3E", color: "#fff", borderRadius: "8px" };

const ModalHeader = ({ title, onClose }) => (
  <div className="flex justify-between items-center mb-2 border-b border-[#1E2030]">
    <h3 className="text-base sm:text-lg font-bold text-white">{title}</h3>
    <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#1A1D2E] hover:bg-[#252840] text-[#8B8FA8] hover:text-white transition-colors">
      <RxCross2 size={16} />
    </button>
  </div>
);

const CurrencyTag = ({ name }) => (
  <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-[#6C5DD3]/15 border border-[#6C5DD3]/30 rounded-full text-xs font-bold text-[#A99FE8]">
    <span className="w-1.5 h-1.5 rounded-full bg-[#6C5DD3]" />{name}
  </span>
);

const TxDetails = ({ hiddenVal, onHiddenChange, noteVal, onNoteChange, NoteLabel }) => (
  <>
    <div className="bg-[#080A12] border border-[#1E2030] rounded-xl p-4 space-y-3">
      <p className="text-xs font-bold text-[#6C5DD3] uppercase tracking-widest">Transaction Details</p>
      <div className="flex items-center justify-between">
        <span className="text-sm text-[#8B8FA8]">Show to user</span>
        <div className="flex items-center gap-2">
          <Switch checked={hiddenVal} onChange={onHiddenChange} />
          <span className="text-xs text-[#8B8FA8]">{hiddenVal ? "Hidden" : "Visible"}</span>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <span className="text-sm text-[#8B8FA8]">Status</span>
        <Badge status="pending" />
      </div>
    </div>
    <Field label={NoteLabel || "Note"}>
      <TextArea value={noteVal} onChange={onNoteChange} rows={3} style={{ ...darkInputStyle, resize: "none" }} placeholder="Add a note..." />
    </Field>
  </>
);


const Usermanagementsettings = () => {
  const [activeTab, setActiveTab] = useState("first");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState({ own: false, ban: false, approve: false, user: false, update: false, withdraw: false, deposit: false });
  const [assets, setAssets] = useState("");
  const [transactions, setTransactions] = useState("");
  const [depositModal, setDeposiitModal] = useState({ open: false, data: "" });
  const [withdrawModal, setWithdrawModal] = useState({ open: false, data: "" });
  const [updateModal, setUpdateModal] = useState({ open: false, data: "" });
  const [updateAdddress, setUpdateAdddress] = useState("");
  const [fiatData, setfiatData] = useState({});
  const [loader, setloader] = useState(false);
  const [loginUser, setLoginUser] = useState([]);
  const { id } = useParams();
  const { t } = useTranslation();
  const [notes, setNotes] = useState({ note: "", swap: "", send: "" });
  const {
    MANAGEASSETS, Update, Withdraw, Deposit, Settings, Editusersettings,
    Emailaddress, FirstName, LastName, Address, City, Country, PostalCode,
    Note, Actions, ActionsMsg, OwnUser, BanUser, Save, ManageTransactions,
    ManageVerification, LoginHistory, TypeKYC, Status, KYCAddres, KYCID,
    View, Approve, Decline, UpdateAsset, Cancel, CreatenewWithdraw, Amount,
    SendAt, Create, CreatenewDeposit, SupportTicket
  } = t("UserManagment", { returnObjects: true });
  const { PendingTickets, Open, Close } = t("SupportTicket", { returnObjects: true });
  const [TicketsData, setTicketsData] = useState('');
  const [withdrawData, setWithdrawData] = useState({ amount: "", send_at: "", hidden: false, tx_id: "", to_address: "", note: "", type: "", user_id: "", asset_id: "", account_number: "", fullname: "" });
  const [depositData, setDepositData] = useState({ amount: "", send_at: "", hidden: false, tx_id: "", from_address: "", note: "", type: "", user_id: "", asset_id: "" });
  const [formData, setFormData] = useState({ fullName: "", iban: "", accountNumber: "", email: "", bankName: "" });
  const fetchData = async () => {
    setloader(true);

    try {
      const res = await handleGet(`${BASE_URL}get/user/assets/${id}`);

      setAssets(res?.assets || []);
      setTicketsData(res?.tickets || []);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setloader(false);
    }
  };


  const fetchUser = async () => {
    const res = await handleGet(`${BASE_URL}get/user/detail/${id}`);
    if (res) {
      setData(res?.user);

      setNotes({
        note: res?.user?.detail?.note || "",
        swap: res?.user?.detail?.swap || "",
        send: res?.user?.detail?.send || "",
      });
    }
  };

  useEffect(() => { fetchData(); fetchUser(); }, [id]);
  useEffect(() => {
    handleGet(`${BASE_URL}active/user/loginhistory/${id}`).then(r => setLoginUser(r?.data));
    handleGet(`${BASE_URL}get/user/assets/${id}`).then(r => { setUpdateAdddress(r?.address); setfiatData(r?.assets?.find(a => a?.id === 6)); });
    handleGet(`${BASE_URL}transaction/get/all?page_number=1`).then(r => setTransactions(r?.transactions));
  }, []);
  useEffect(() => {
    setFormData({ fullName: fiatData?.fullname || "", iban: fiatData?.iban_number || "", accountNumber: fiatData?.account_number || "", email: fiatData?.email || "", bankName: fiatData?.bank_name || "" });
  }, [fiatData]);

  const handleUpdateUser = async () => {
    setLoading(p => ({ ...p, user: true }));
    try {
      await handlePost(`${BASE_URL}update/user/${id}`, {
        name: data.name,
        email: data.email,
        "details[phone_number]": data?.detail?.phone_number,
        "details[address]": data?.detail?.address,
        "details[city]": data?.detail?.city,
        "details[country]": data?.detail?.country,
        "details[postal_code]": data?.detail?.postal_code,
        "details[note]": notes.note,
        "details[swap]": notes.swap,
        "details[send]": notes.send,
        "details[is_swap]": data?.detail?.is_swap,
        "details[is_send]": data?.detail?.is_send,
      });
    } finally {
      setLoading(p => ({ ...p, user: false }));
    }
  };

  const handleUserStatus = async (status) => {
    status === "approved" ? setLoading(p => ({ ...p, approve: true, ban: false })) : setLoading(p => ({ ...p, ban: true, approve: false }));
    try { await handlePost(`${BASE_URL}user/approve/kyc/${id}`, { status }); fetchUser(); }
    finally { setLoading(p => ({ ...p, ban: false, approve: false })); }
  };
  const handleUserBan = async (action) => {
    action === "ban" ? setLoading(p => ({ ...p, ban: true, approve: false })) : setLoading(p => ({ ...p, approve: true, ban: false }));
    try { await handlePost(`${BASE_URL}user/update/status/${id}`, { status: action }); }
    finally { setLoading(p => ({ ...p, ban: false, approve: false })); }
  };
  const handleCloseDeposit = () => { setDepositData({ amount: "", send_at: "", hidden: false, tx_id: "", from_address: "", note: "", type: "", user_id: "", asset_id: "" }); setDeposiitModal(false); };
  const handleCloseWithdraw = () => { setWithdrawData({ amount: "", send_at: "", hidden: false, tx_id: "", to_address: "", note: "", type: "", user_id: "", asset_id: "", account_number: "", fullname: "" }); setWithdrawModal(false); };
  const handleCloseUpdate = () => setUpdateModal(false);
  const handleUpdateAssets = async () => {
    setLoading(p => ({ ...p, update: true }));
    try { await handlePost(`${BASE_URL}update/asset/address`, { user_id: id, address: updateAdddress, asset_id: updateModal?.data?.id }); setUpdateModal(false); fetchData(); }
    finally { setLoading(p => ({ ...p, update: false })); }
  };
  const handleUpdateAssetsFiat = async () => {
    setLoading(p => ({ ...p, update: true }));
    try { await handlePost(`${BASE_URL}update/asset/flataddress`, { user_id: id, asset_id: updateModal?.data?.id, fullname: formData.fullName, bank_name: formData.bankName, iban_number: formData.iban, account_number: formData.accountNumber, email: formData.email }); setUpdateModal(false); fetchData(); }
    finally { setLoading(p => ({ ...p, update: false })); }
  };
  const handleWithdrawAssets = async () => {
    setLoading(p => ({ ...p, withdraw: true }));
    try { const r = await handlePost(`${BASE_URL}transaction/make/withdraw`, { ...withdrawData, hidden: withdrawData?.hidden ? 1 : 0, asset_id: withdrawModal?.data?.id, user_id: id, type: "withdraw", send_at: withdrawData?.send_at ? dayjs(withdrawData.send_at).format("DD/MM/YYYY hh:mm:ss") : dayjs().format("DD/MM/YYYY hh:mm:ss") }); if (r) { setWithdrawData(""); setWithdrawModal(false); } }
    finally { setLoading(p => ({ ...p, withdraw: false })); }
  };
  const handleDepositAsset = async () => {
    setLoading(p => ({ ...p, deposit: true }));
    try { const r = await handlePost(`${BASE_URL}transaction/make/deposit`, { ...depositData, hidden: depositData?.hidden ? 1 : 0, asset_id: depositModal?.data?.id, user_id: id, type: "deposit", send_at: depositData?.send_at ? dayjs(depositData.send_at).format("DD/MM/YYYY hh:mm:ss") : dayjs().format("DD/MM/YYYY hh:mm:ss") }); if (r) { setDepositData(""); setDeposiitModal(false); } }
    finally { setLoading(p => ({ ...p, deposit: false })); }
  };


  const modalStyles = {
    content: { background: "#0D0F1A", border: "1px solid #1E2030", borderRadius: "16px", padding: "10px" },
    mask: { backdropFilter: "blur(4px)", background: "rgba(0,0,0,0.7)" },
  };



  if (!data) return (
    <div className="min-h-screen bg-[#080A12] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-2 border-[#6C5DD3] border-t-transparent rounded-full animate-spin" />
        <p className="text-[#8B8FA8] text-sm">Loading user data...</p>
      </div>
    </div>
  );

  const initials = (data?.name || "U").split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);

  return (
    <div className="min-h-screen bg-[#080A12] p-3 sm:p-4 lg:p-6 font-sans">

      {/* ── Deposit Modal ── */}
      <Modal open={depositModal?.open} footer={null} closable={false} centered styles={modalStyles}>
        <ModalHeader title={CreatenewDeposit || "New Deposit"} onClose={handleCloseDeposit} />
        <div className="space-y-4 max-h-[72vh] overflow-y-auto pr-0.5">
          <div className="flex items-center gap-3">
            <span className="text-xs text-[#8B8FA8] uppercase tracking-widest">Currency</span>
            <CurrencyTag name={depositModal?.data?.name} />
          </div>
          <Field label={Amount || "Amount"}>
            <InputNumber min={0} step={1} keyboard={false} value={depositData?.amount} onChange={e => setDepositData({ ...depositData, amount: e })} className="w-full" size="large" placeholder="0.00000" style={darkInputStyle} />
          </Field>
          {depositModal?.data?.name !== "Fiat" ? (
            <>
              <Field label="Transaction ID">
                <InputNumber min={0} step={1} keyboard={false} value={depositData?.tx_id} onChange={e => setDepositData({ ...depositData, tx_id: e })} className="w-full" size="large" placeholder="Tx ID" style={darkInputStyle} />
              </Field>
              <Field label="From Address">
                <Input value={depositData?.from_address} onChange={e => setDepositData({ ...depositData, from_address: e.target.value })} size="large" placeholder="0x..." style={darkInputStyle} />
              </Field>
            </>
          ) : (
            <>
              <Field label="Full Name">
                <Input value={depositData?.fullname} onChange={e => setDepositData({ ...depositData, fullname: e.target.value })} size="large" placeholder="John Doe" style={darkInputStyle} />
              </Field>
              <Field label="Account Number">
                <InputNumber min={0} step={1} keyboard={false} value={depositData?.account_number} onChange={e => setDepositData({ ...depositData, account_number: e })} className="w-full" size="large" placeholder="1234" style={darkInputStyle} />
              </Field>
            </>
          )}
          <Field label={SendAt || "Send At"}>
            <DatePicker value={depositData?.send_at ? dayjs(depositData.send_at) : dayjs()} onChange={date => setDepositData({ ...depositData, send_at: date })} className="w-full" size="large" allowClear={false} showTime format="DD/MM/YYYY hh:mm A" style={darkInputStyle} />
          </Field>
          <TxDetails hiddenVal={depositData?.hidden} onHiddenChange={e => setDepositData({ ...depositData, hidden: e })} noteVal={depositData?.note} onNoteChange={e => setDepositData({ ...depositData, note: e.target.value })} NoteLabel={Note} />
          <div className="flex justify-end gap-3 pt-2">
            <GlowBtn variant="ghost" onClick={handleCloseDeposit}>{Cancel || "Cancel"}</GlowBtn>
            <GlowBtn loading={loading?.deposit} onClick={handleDepositAsset}>{Create || "Create"}</GlowBtn>
          </div>
        </div>
      </Modal>

      {/* ── Withdraw Modal ── */}
      <Modal width="min(560px, 95vw)" open={withdrawModal?.open} footer={null} closable={false} centered styles={modalStyles}>
        <ModalHeader title={CreatenewWithdraw || "New Withdrawal"} onClose={handleCloseWithdraw} />
        <div className="space-y-4 max-h-[72vh] overflow-y-auto pr-0.5">
          <div className="flex items-center gap-3">
            <span className="text-xs text-[#8B8FA8] uppercase tracking-widest">Currency</span>
            <CurrencyTag name={withdrawModal?.data?.name} />
          </div>
          <Field label={Amount || "Amount"}>
            <InputNumber step={1} keyboard={false} min={0} value={withdrawData?.amount} onChange={v => setWithdrawData({ ...withdrawData, amount: v })} className="w-full" size="large" placeholder="0.00000" style={darkInputStyle} />
          </Field>
          {withdrawModal?.data?.name === "Fiat" && (
            <>
              <Field label="Full Name">
                <Input value={withdrawData?.fullname} onChange={e => setWithdrawData({ ...withdrawData, fullname: e.target.value })} size="large" placeholder="John Doe" style={darkInputStyle} />
              </Field>
              <Field label="Account Number">
                <InputNumber min={0} step={1} keyboard={false} value={withdrawData?.account_number} onChange={e => setWithdrawData({ ...withdrawData, account_number: e })} className="w-full" size="large" placeholder="1234" style={darkInputStyle} />
              </Field>
            </>
          )}
          <Field label={SendAt || "Send At"}>
            <DatePicker value={withdrawData?.send_at ? dayjs(withdrawData.send_at) : dayjs()} onChange={date => setWithdrawData({ ...withdrawData, send_at: date })} className="w-full" size="large" allowClear={false} showTime format="DD/MM/YYYY hh:mm A" style={darkInputStyle} />
          </Field>
          <TxDetails hiddenVal={withdrawData?.hidden} onHiddenChange={e => setWithdrawData({ ...withdrawData, hidden: e })} noteVal={withdrawData?.note} onNoteChange={e => setWithdrawData({ ...withdrawData, note: e.target.value })} NoteLabel={Note} />
          <div className="flex justify-end gap-3 pt-2">
            <GlowBtn variant="ghost" onClick={handleCloseWithdraw}>{Cancel || "Cancel"}</GlowBtn>
            <GlowBtn loading={loading?.withdraw} onClick={handleWithdrawAssets}>{Create || "Create"}</GlowBtn>
          </div>
        </div>
      </Modal>

      {/* ── Update Asset Modal ── */}
      <Modal open={updateModal?.open} footer={null} closable={false} centered styles={modalStyles}>
        <ModalHeader title={UpdateAsset || "Update Asset"} onClose={handleCloseUpdate} />
        {updateModal?.data?.name === "Fiat" ? (
          <div className="space-y-3">
            {[["Full Name", "fullName", "John Doe"], ["IBAN Number", "iban", "DE89 3704 0044"], ["Account #", "accountNumber", "1234"], ["Email", "email", "user@bank.com"], ["Bank Name", "bankName", "Deutsche Bank"]].map(([label, name, ph]) => (
              <Field key={name} label={label}>
                <Input value={formData[name]} onChange={e => setFormData(p => ({ ...p, [name]: e.target.value }))} size="large" placeholder={ph} style={darkInputStyle} />
              </Field>
            ))}
          </div>
        ) : (
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-4">
              <span className="text-xs text-[#8B8FA8] uppercase tracking-widest">Currency</span>
              <CurrencyTag name={updateModal?.data?.name} />
            </div>
            <Field label={Address || "Address"}>
              <Input value={updateAdddress} onChange={e => setUpdateAdddress(e.target.value)} size="large" placeholder="0x..." style={darkInputStyle} />
            </Field>
          </div>
        )}
        <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-[#1E2030]">
          <GlowBtn variant="ghost" onClick={handleCloseUpdate}>{Cancel || "Cancel"}</GlowBtn>
          <GlowBtn loading={loading?.update} onClick={updateModal?.data?.name === "Fiat" ? handleUpdateAssetsFiat : handleUpdateAssets}>{Update || "Update"}</GlowBtn>
        </div>
      </Modal>

      {/* ══════════ MAIN LAYOUT ══════════ */}
      <div className="max-w-6xl mx-auto">

        {/* ── User header ── */}
        <div className="flex items-center gap-3 sm:gap-5 mb-4 sm:mb-6 lg:mb-8 p-3 sm:p-4 bg-[#0b1629] border border-[#1E2030] rounded-2xl">
          <div className="relative shrink-0">
            <div className="w-11 h-11 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-gradient-to-br from-[#6C5DD3] to-[#9B8EE8] flex items-center justify-center text-white text-sm sm:text-xl font-bold shadow-[0_0_24px_rgba(108,93,211,0.4)]">
              {initials}
            </div>
            <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 sm:w-4 sm:h-4 rounded-full bg-emerald-400 border-2 border-[#0D0F1A]" />
          </div>
          <div className="flex-1 min-w-0">
            <h1 className="text-sm sm:text-xl font-bold text-white truncate">{data?.name || "—"}</h1>
            <p className="text-xs sm:text-sm text-[#8B8FA8] truncate">{data?.email}</p>
          </div>
          <div className="shrink-0">
            <Badge status={data?.active_status || "pending"} />
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-3 sm:gap-4 lg:gap-6">

          {/* ── Mobile/tablet: horizontal pill tabs ── */}
          <div className="lg:hidden">
            <div className="bg-[#0D0F1A] border border-[#1E2030] rounded-2xl p-1.5 flex gap-1 overflow-x-auto"
              style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
              {NAV_ITEMS.map(({ key, icon: Icon, label }) => {
                const active = activeTab === key;
                return (
                  <button
                    key={key}
                    onClick={() => setActiveTab(key)}
                    className={`flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-semibold whitespace-nowrap transition-all duration-200 shrink-0
                      ${active ? "bg-[#6C5DD3] text-white shadow-[0_0_12px_rgba(108,93,211,0.3)]" : "text-[#8B8FA8] hover:bg-[#161826] hover:text-white"}`}
                  >
                    <Icon size={13} />
                    {label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* ── Desktop: vertical sidebar ── */}
          <aside className="hidden lg:block w-52 shrink-0">
            <nav className="bg-[#0D0F1A] border border-[#1E2030] rounded-2xl p-2 space-y-1">
              {NAV_ITEMS.map(({ key, icon: Icon, label }) => {
                const active = activeTab === key;
                return (
                  <button
                    key={key}
                    onClick={() => setActiveTab(key)}
                    className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 text-left group
                      ${active ? "bg-[#6C5DD3] text-white shadow-[0_0_16px_rgba(108,93,211,0.3)]" : "text-[#8B8FA8] hover:bg-[#161826] hover:text-white"}`}
                  >
                    <Icon size={16} className={active ? "text-white" : "text-[#8B8FA8] group-hover:text-[#6C5DD3]"} />
                    <span className="text-xs tracking-wide">{label}</span>
                    {active && <span className="ml-auto w-1.5 h-1.5 rounded-full bg-white/60" />}
                  </button>
                );
              })}
            </nav>
          </aside>

          {/* ── Main content panel ── */}
          <main className="flex-1 min-w-0 bg-[#0D0F1A] border border-[#1E2030] rounded-2xl p-4 sm:p-6 lg:p-8">

            {/* ══ GENERAL ══ */}
            {activeTab === "first" && (
              <div>
                <div className="flex items-start justify-between mb-5 pb-4 border-b border-[#1E2030]">
                  <div>
                    <h2 className="text-base sm:text-lg font-bold text-white">{Settings || "Settings"}</h2>
                    <p className="text-xs text-[#8B8FA8] mt-0.5">{Editusersettings || "Edit user profile settings"}</p>
                  </div>
                  <GlowBtn loading={loading?.user} onClick={handleUpdateUser}>
                    <AiFillSave size={14} />
                    <span>{Save || "Save"}</span>
                  </GlowBtn>
                </div>

                <Field label={Emailaddress || "Email Address"}>
                  <Input value={data?.email} size="large" disabled prefix={<CiMail className="text-[#8B8FA8]" />} style={{ ...darkInputStyle, opacity: 0.6 }} />
                </Field>

                {/* 2-col on sm+, 1-col on mobile */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5">
                  <Field label={FirstName || "First Name"}>
                    <Input value={data?.name} onChange={e => setData({ ...data, name: e.target.value })} size="large" placeholder="John" style={darkInputStyle} />
                  </Field>
                  <Field label={LastName || "Last Name"}>
                    <Input value={data?.last_name} onChange={e => setData({ ...data, last_name: e.target.value })} size="large" placeholder="Grant" style={darkInputStyle} />
                  </Field>
                  <Field label={Address || "Address"}>
                    <Input value={data?.detail?.address} onChange={e => setData({ ...data, detail: { ...data?.detail, address: e.target.value } })} size="large" placeholder="27 Grayson Drive" prefix={<GoLocation className="text-[#8B8FA8]" />} style={darkInputStyle} />
                  </Field>
                  <Field label={City || "City"}>
                    <Input value={data?.detail?.city} onChange={e => setData({ ...data, detail: { ...data?.detail, city: e.target.value } })} size="large" placeholder="Oakhill" prefix={<BiSolidCity className="text-[#8B8FA8]" />} style={darkInputStyle} />
                  </Field>
                  <Field label={Country || "Country"}>
                    <Input value={data?.detail?.country} onChange={e => setData({ ...data, detail: { ...data?.detail, country: e.target.value } })} size="large" placeholder="Canada" style={darkInputStyle} />
                  </Field>
                  <Field label={PostalCode || "Postal Code"}>
                    <Input value={data?.detail?.postal_code} onChange={e => setData({ ...data, detail: { ...data?.detail, postal_code: e.target.value } })} size="large" placeholder="B4V 0E5" style={darkInputStyle} />
                  </Field>
                </div>

                {[
                  { label: Note || "Note", toggleKey: null, noteKey: "note", swapKey: null },
                  { label: "Swap Note", toggleKey: "is_swap", noteKey: "swap", swapKey: "is_swap" },
                  { label: "Send Note", toggleKey: "is_send", noteKey: "send", swapKey: "is_send" },
                ].map(({ label, toggleKey, noteKey, swapKey }) => (
                  <div key={noteKey} className="mt-2">
                    <div className="flex items-center justify-between mb-1.5">
                      <label className="text-xs font-semibold text-[#8B8FA8] uppercase tracking-widest">{label}</label>
                      {toggleKey && (
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-[#8B8FA8]">{data?.detail?.[toggleKey] ? "Enabled" : "Disabled"}</span>
                          <Switch
                            checked={data?.detail?.[toggleKey]}
                            onChange={v => setData(p => ({ ...p, detail: { ...p?.detail, [swapKey]: v } }))}
                          />
                        </div>
                      )}
                    </div>
                    <TextArea
                      value={notes[noteKey]}
                      onChange={e => setNotes(p => ({ ...p, [noteKey]: e.target.value }))}
                      rows={3}
                      style={{ ...darkInputStyle, resize: "none" }}
                      placeholder="Add note..."
                      className="mb-4"
                    />
                  </div>
                ))}

                <div className="mt-6 p-4 bg-[#080A12] border border-[#1E2030] rounded-xl">
                  <p className="text-xs font-bold text-[#6C5DD3] uppercase tracking-widest mb-1">{Actions || "Actions"}</p>
                  <p className="text-xs text-[#8B8FA8] mb-4">{ActionsMsg || "Manage user account status"}</p>
                  <div className="flex flex-wrap gap-3">
                    <GlowBtn variant="success" loading={loading?.approve} onClick={() => handleUserBan("unban")}>
                      <GoRocket size={14} /> {OwnUser || "Unban"}
                    </GlowBtn>
                    <GlowBtn variant="danger" loading={loading?.ban} onClick={() => handleUserBan("ban")}>
                      <FaBan size={12} /> {BanUser || "Ban User"}
                    </GlowBtn>
                  </div>
                </div>
              </div>
            )}

            {/* ══ MANAGE ASSETS ══ */}
            {activeTab === "second" && (
              <div>
                <div className="mb-5 pb-4 border-b border-[#1E2030]">
                  <h2 className="text-base sm:text-lg font-bold text-white">{MANAGEASSETS || "Manage Assets"}</h2>
                  <p className="text-xs text-[#8B8FA8] mt-0.5">{Array.isArray(assets) ? `${assets.length} assets` : "Loading..."}</p>
                </div>
                {loader ? (
                  <div className="flex justify-center py-12">
                    <div className="w-8 h-8 border-2 border-[#6C5DD3] border-t-transparent rounded-full animate-spin" />
                  </div>
                ) : (
                  <div className="space-y-2">
                    {/* Column header – tablet+ only */}
                    <div className="hidden md:grid grid-cols-12 px-4 py-2 text-xs font-semibold text-[#8B8FA8] uppercase tracking-widest">
                      <div className="col-span-3">Asset</div>
                      <div className="col-span-4">Balance (USD)</div>
                      <div className="col-span-5 text-right">Actions</div>
                    </div>

                    {Array.isArray(assets) && assets.map((item) => (
                      <div key={item?.id} className="bg-[#080A12] border border-[#1E2030] rounded-xl hover:border-[#6C5DD3]/30 transition-colors">

                        {/* Mobile card */}
                        <div className="md:hidden p-3 space-y-3">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <div className="w-9 h-9 rounded-xl bg-[#7b4dff] border border-[#2A2D3E] flex items-center justify-center shrink-0">
                                <img src={item?.symbol} className="w-5 h-5 object-contain" alt={item?.name} />
                              </div>
                              <div>
                                <p className="text-sm font-bold text-white">{item?.name}</p>
                                <p className="text-xs text-[#8B8FA8]">{item?.short_name} · {item?.amount}</p>
                              </div>
                            </div>
                            <p className="text-sm text-[#6C5DD3] font-bold shrink-0">${item?.amount_usd ?? "0.00"}</p>
                          </div>
                          <div className="grid grid-cols-3 gap-1.5">
                            <button onClick={() => { setUpdateModal({ open: true, data: item }); setUpdateAdddress(item?.address); }} className="flex items-center justify-center gap-1 py-2 text-xs bg-[#161826] border border-[#2A2D3E] text-[#8B8FA8] rounded-lg transition-all hover:border-[#6C5DD3]/50 hover:text-white">
                              <PiArrowsClockwiseBold size={11} /> Update
                            </button>
                            <button onClick={() => setWithdrawModal({ open: true, data: item })} className="flex items-center justify-center gap-1 py-2 text-xs bg-red-500/5 border border-red-500/20 text-red-400 rounded-lg transition-all hover:border-red-500/50">
                              <HiOutlineArrowDownRight size={11} /> Out
                            </button>
                            <button onClick={() => setDeposiitModal({ open: true, data: item })} className="flex items-center justify-center gap-1 py-2 text-xs bg-emerald-500/5 border border-emerald-500/20 text-emerald-400 rounded-lg transition-all hover:border-emerald-500/50">
                              <HiArrowUpLeft size={11} /> In
                            </button>
                          </div>
                        </div>

                        {/* Tablet/desktop row */}
                        <div className="hidden md:grid grid-cols-12 items-center px-4 py-3">
                          <div className="col-span-3 flex items-center gap-3">
                            <div className="w-9 h-9 rounded-xl bg-[#7b4dff] border border-[#2A2D3E] flex items-center justify-center shrink-0">
                              <img src={item?.symbol} className="w-5 h-5 object-contain" alt={item?.name} />
                            </div>
                            <div>
                              <p className="text-sm font-bold text-white">{item?.name}</p>
                              <p className="text-xs text-[#8B8FA8]">{item?.short_name} · {item?.amount}</p>
                            </div>
                          </div>

                          <div className="col-span-4 overflow-hidden">
                            <p className="text-sm text-[#6C5DD3] font-bold truncate">
                              ${item?.amount_usd === null ? "0.00" : `${item?.amount_usd}.00`}
                            </p>
                          </div>

                          <div className="col-span-5 flex justify-end gap-2 shrink-0">
                            <button onClick={() => { setUpdateModal({ open: true, data: item }); setUpdateAdddress(item?.address); }} className="flex items-center gap-1.5 px-3 py-1.5 text-xs bg-[#161826] border border-[#2A2D3E] hover:border-[#6C5DD3]/50 text-[#8B8FA8] hover:text-white rounded-lg transition-all whitespace-nowrap">
                              <PiArrowsClockwiseBold size={12} /> {Update || "Update"}
                            </button>
                            <button onClick={() => setWithdrawModal({ open: true, data: item })} className="flex items-center gap-1.5 px-3 py-1.5 text-xs bg-red-500/5 border border-red-500/20 hover:border-red-500/50 text-red-400 rounded-lg transition-all whitespace-nowrap">
                              <HiOutlineArrowDownRight size={12} /> {Withdraw || "Withdraw"}
                            </button>
                            <button onClick={() => setDeposiitModal({ open: true, data: item })} className="flex items-center gap-1.5 px-3 py-1.5 text-xs bg-emerald-500/5 border border-emerald-500/20 hover:border-emerald-500/50 text-emerald-400 rounded-lg transition-all whitespace-nowrap">
                              <HiArrowUpLeft size={12} /> {Deposit || "Deposit"}
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* ══ TRANSACTIONS ══ */}
            {activeTab === "third" && (
              <div>
                <div className="mb-5 pb-4 border-b border-[#1E2030]">
                  <h2 className="text-base sm:text-lg font-bold text-white">{ManageTransactions || "Transactions"}</h2>
                </div>
                <div className="space-y-2">
                  <div className="hidden md:grid grid-cols-12 px-4 py-2 text-xs font-semibold text-[#8B8FA8] uppercase tracking-widest">
                    <div className="col-span-5">Asset</div>
                    <div className="col-span-3">Amount</div>
                    <div className="col-span-4">Status</div>
                  </div>
                  {Array.isArray(transactions) && transactions.map((item) => (
                    <div key={item?.id} className="bg-[#080A12] border border-[#1E2030] rounded-xl hover:border-[#6C5DD3]/30 transition-colors">
                      {/* Mobile */}
                      <div className="md:hidden flex items-center justify-between p-3">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-lg bg-[#7b4dff] border border-[#2A2D3E] flex items-center justify-center shrink-0">
                            <img src={item?.asset?.symbol} className="w-4 h-4 object-contain" alt="asset" />
                          </div>
                          <div>
                            <p className="text-sm font-bold text-white">{item?.asset?.name}</p>
                            <p className="text-xs text-[#8B8FA8] capitalize">{item?.type || "—"} · {item?.amount}</p>
                          </div>
                        </div>
                        <Badge status={item?.status} />
                      </div>
                      {/* Desktop */}
                      <div className="hidden md:grid grid-cols-12 items-center px-4 py-3">
                        <div className="col-span-5 flex items-center gap-3">
                          <div className="w-9 h-9 rounded-xl bg-[#7b4dff] border border-[#2A2D3E] flex items-center justify-center">
                            <img src={item?.asset?.symbol} className="w-5 h-5 object-contain" alt="asset" />
                          </div>
                          <div>
                            <p className="text-sm font-bold text-white">{item?.asset?.name}</p>
                            <p className="text-xs text-[#8B8FA8] capitalize">{item?.type || "—"}</p>
                          </div>
                        </div>
                        <div className="col-span-3"><p className="text-sm text-white">{item?.amount}</p></div>
                        <div className="col-span-4"><Badge status={item?.status} /></div>
                      </div>
                    </div>
                  ))}
                  {(!transactions || transactions.length === 0) && (
                    <div className="text-center py-12 text-[#8B8FA8] text-sm">No transactions found</div>
                  )}
                </div>
              </div>
            )}

            {/* ══ VERIFICATION ══ */}
            {activeTab === "fourth" && (
              <div>
                <div className="mb-5 pb-4 border-b border-[#1E2030]">
                  <h2 className="text-base sm:text-lg font-bold text-white">{ManageVerification || "Verification"}</h2>
                </div>
                <div className="bg-[#080A12] border border-[#1E2030] rounded-xl p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-[#161826] border border-[#2A2D3E] flex items-center justify-center shrink-0">
                      <img src={secure} className="w-5 h-5" alt="kyc" />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-white">{TypeKYC || "KYC Verification"}</p>
                      <div className="flex items-center gap-2 mt-1">
                        <span className="text-xs text-[#8B8FA8]">{Status || "Status"}:</span>
                        <Badge status={data?.active_status} />
                      </div>
                    </div>
                  </div>
                  <Dropdown placement="bottomLeft" trigger={["click"]} dropdownRender={() => (
                    <div className="bg-[#0D0F1A] border border-[#1E2030] rounded-xl shadow-2xl p-2 min-w-[180px]">
                      {[{ label: KYCAddres || "KYC Address", href: data?.kyc_document_address }, { label: KYCID || "KYC ID", href: data?.kyc_document_id }].map(({ label, href }) => (
                        <a key={label} href={href} target="_blank" rel="noreferrer" className="flex items-center gap-2 px-3 py-2 text-sm text-[#8B8FA8] hover:text-white hover:bg-[#161826] rounded-lg transition-colors">
                          <HiDocumentDownload size={16} className="text-[#6C5DD3]" /> {label}
                        </a>
                      ))}
                    </div>
                  )}>
                    <button className="self-start sm:self-auto flex items-center gap-2 px-4 py-2 bg-[#161826] border border-[#2A2D3E] hover:border-[#6C5DD3]/50 rounded-xl text-sm text-[#8B8FA8] hover:text-white transition-all">
                      <FaEye size={12} className="text-[#6C5DD3] cursor-pointer" />  {View || "View Docs"}
                    </button>
                  </Dropdown>
                </div>
                <div className="flex flex-wrap gap-3 mt-5">
                  <GlowBtn loading={loading?.approve} onClick={() => handleUserStatus("approved")}>
                    <GoRocket size={14} /> {Approve || "Approve"}
                  </GlowBtn>
                  <GlowBtn variant="danger" loading={loading?.ban} onClick={() => handleUserStatus("declined")}>
                    <FaBan size={12} /> {Decline || "Decline"}
                  </GlowBtn>
                </div>
              </div>
            )}

            {/* ══ LOGIN HISTORY ══ */}
            {activeTab === "fifth" && (
              <div>
                <div className="mb-5 pb-4 border-b border-[#1E2030]">
                  <h2 className="text-base sm:text-lg font-bold text-white">{LoginHistory || "Login History"}</h2>
                </div>

                {/* Mobile: stacked cards */}
                <div className="md:hidden space-y-2">
                  {loginUser?.map((item, i) => (
                    <div key={i} className="bg-[#080A12] border border-[#1E2030] rounded-xl p-4 space-y-3">
                      <div className="flex items-center justify-between">
                        <p className="text-sm font-semibold text-white truncate pr-2">{item?.device || "Unknown device"}</p>
                        <Badge status={item?.status || "active"} />
                      </div>
                      <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs">
                        {[["Browser", item?.browser], ["Location", item?.location], ["Platform", item?.platform], ["IP", item?.ip_address]].map(([lbl, val]) => (
                          <div key={lbl}>
                            <p className="text-[#3D4160] uppercase tracking-wider text-[10px] mb-0.5">{lbl}</p>
                            <p className="text-[#8B8FA8] truncate">{val || "—"}</p>
                          </div>
                        ))}
                      </div>
                      <div className="grid grid-cols-2 gap-x-4 text-xs pt-2 border-t border-[#1E2030]">
                        <div>
                          <p className="text-[#3D4160] uppercase tracking-wider text-[10px] mb-0.5">Login</p>
                          <p className="text-[#8B8FA8]">{item?.login_timestamp || "—"}</p>
                        </div>
                        <div>
                          <p className="text-[#3D4160] uppercase tracking-wider text-[10px] mb-0.5">Logout</p>
                          <p className="text-[#8B8FA8]">{item?.logout_timestamp || "—"}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                  {(!loginUser || loginUser.length === 0) && (
                    <div className="text-center py-12 text-[#8B8FA8] text-sm">No login history found</div>
                  )}
                </div>

                {/* Tablet/Desktop: table */}
                <div className="hidden md:block overflow-x-auto rounded-xl border border-[#1E2030]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#080A12]">
                        {["Device", "Browser", "Location", "Platform", "IP Address", "Login", "Logout", "Status"].map(h => (
                          <th key={h} className="px-4 py-3 text-left text-xs font-bold text-[#8B8FA8] uppercase tracking-widest whitespace-nowrap border-b border-[#1E2030]">{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-[#1E2030]">
                      {loginUser?.map((item, i) => (
                        <tr key={i} className="hover:bg-[#080A12]/60 transition-colors">
                          {[item?.device, item?.browser, item?.location, item?.platform, item?.ip_address, item?.login_timestamp, item?.logout_timestamp].map((val, j) => (
                            <td key={j} className="px-4 py-3 text-[#8B8FA8] text-xs whitespace-nowrap">{val || "—"}</td>
                          ))}
                          <td className="px-4 py-3"><Badge status={item?.status || "active"} /></td>
                        </tr>
                      ))}
                      {(!loginUser || loginUser.length === 0) && (
                        <tr><td colSpan={8} className="text-center py-12 text-[#8B8FA8] text-xs">No login history found</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            {/* ══ Support ══ */}
            {activeTab === "sixth" && (
              <div>
                <div className="pb-4 border-b border-[#1E2030]">
                  <h2 className="text-base sm:text-lg font-bold text-white">{SupportTicket || "Support Tickets"}</h2>
                </div>
                {loader ?
                  <div className='min-h-[420px] h-full w-full flex items-center justify-center'>
                    <Spin size='large' />
                  </div> :
                  <div className='w-full min-w-[880px] flex min-h-[420px] justify-center'>
                    <TicketTable fetchData={fetchData} link='/admin' loader={loader} data={TicketsData} />
                  </div>
                }
              </div>

            )}

          </main>
        </div>
      </div>
    </div>
  );
};

export default Usermanagementsettings;